module.exports = "<span ng-bind=\"$ctrl.getName()\" ng-if=\"$ctrl.mode === 'view'\"></span>\n<select class=\"form-control\" ng-class=\"$ctrl.inputClass\" ng-model=\"$ctrl.ngModel\" ng-options=\"opt[0] as opt[1] for opt in $ctrl.statuses\" ng-if=\"$ctrl.mode === 'edit'\"></select>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/order.status.html
// module id = 591
// module chunks = 0